// Time helpers for the app's business timezone.
//
// The backend runs with TIME_ZONE = 'Asia/Yerevan' (UTC+4, no DST) and USE_TZ=True,
// so a naive datetime submitted from a <input type="datetime-local"> is interpreted
// as Yerevan wall-clock time. Defaults for such inputs must therefore be the current
// Yerevan wall-clock — NOT `new Date().toISOString()`, which is UTC (4h behind) and
// would both display the wrong time and, if left unchanged, store the wrong time.

// Current Yerevan/Tbilisi (UTC+4) wall-clock as 'YYYY-MM-DDTHH:mm' for datetime-local.
export function nowLocalInput() {
  return new Date(Date.now() + 4 * 3600 * 1000).toISOString().slice(0, 16);
}
